/*
  Gaveta dos kits nas paginas de campanha (sections/biobio-aniversario.liquid, 21/10/2026).

  O botao "Escolher tons" de um kit (biobio-product-card com kit_gaveta, atributo data-kit-gaveta com o handle)
  abre a MESMA gaveta do destaque do Trio Essencial: casca snippets/biobio-quick-shop.liquid + assets/biobio-trio.js,
  bottom sheet no celular e gaveta a direita a partir de 750px. O biobio-trio.js nao muda: ele porta para dentro
  do drawer o <bundle-selector> que estiver no host unico da pagina ([data-trio-selector-host]). Este arquivo so
  troca QUAL seletor esta no host antes de abrir.

  - Seletor do kit: /products/<handle>?section_id=biobio-kit-gaveta (Section Rendering API, sections/
    biobio-kit-gaveta.liquid), buscado no primeiro toque (ou ja na intencao, pointerdown/touchstart) e guardado
    para a visita. Os <link> e <script src> do fragmento entram na pagina uma vez (scripts inseridos por
    innerHTML nao executam). No DOM fica UM <bundle-selector> por vez: os outros esperam fora dele, porque o
    finder de tom do biobio-trio.js aplica o tom no primeiro bundle-selector do documento.
  - Pagina com destaque do Trio (VIP): o host e os assets sao os do destaque, e o seletor do Trio volta para o
    host antes de o botao do destaque ou o "Nao sabe seu tom?" agirem (listener em captura).
  - Pagina sem destaque (Orange Friday normal): a section imprime a casca, um host vazio e
    [data-kit-gaveta-assets] com as URLs do biobio-trio.css/js, carregados so na primeira intencao.
  - Falha (rede, fragmento sem seletor, teto de 10 s) ou kit em modo avulso da campanha do site
    (bundle-selector[data-kit-avulso], o destaque tambem vira link nesse caso): vai para a PDP do kit.
  - O biobio-trio.css esconde a faixa de campanha do topo com !important (regra da PDP do Trio). Antes de
    injetar a folha, as sections com a faixa viva ganham colecao-copa-viva, que o biobio-aniversario.css usa
    para devolver o display (o mesmo que o biobio-colecao-editorial.js faz na Makecare).
*/
(function () {
  if (window.__biobioKitGavetaInit) return;
  window.__biobioKitGavetaInit = true;

  var SEL_BOTAO = '[data-kit-gaveta]';
  var SEL_DESTAQUE = '[data-colecao-destaque] [data-trio-open-bundle], [data-trio-finder-trigger]';
  var TEMPO_LIMITE = window.__kitGavetaTempoLimite || 10000;

  var seletores = new Map(); // handle -> Promise do <bundle-selector> pronto para entrar no host
  var cargaTrio = null;
  var original = null; // { no } seletor do destaque, o dono do host

  function noop() {}
  function pronto() { return !!window.__biobioTrioReady; }
  function host() { return document.querySelector('[data-trio-selector-host]'); }
  function fonteAssets() {
    return document.querySelector('[data-colecao-trio-assets]') || document.querySelector('[data-kit-gaveta-assets]');
  }

  function comTeto(promessa) {
    var teto = new Promise(function (ok, erro) {
      setTimeout(function () { erro(new Error('gaveta do kit passou do teto')); }, TEMPO_LIMITE);
    });
    return Promise.race([promessa, teto]);
  }

  function injetarCss(href, extra) {
    if (!href) return Promise.resolve();
    var existente = document.querySelector('link[href="' + href + '"]');
    if (existente) return Promise.resolve(existente);
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    if (extra) l.setAttribute(extra, '');
    var p = new Promise(function (ok, erro) { l.onload = function () { ok(l); }; l.onerror = erro; });
    document.head.appendChild(l);
    return p;
  }

  var scriptsCarregando = new Map();
  function injetarJs(src) {
    if (!src) return Promise.resolve();
    if (scriptsCarregando.has(src)) return scriptsCarregando.get(src);
    if (document.querySelector('script[src="' + src + '"]')) return Promise.resolve();
    var sc = document.createElement('script');
    sc.src = src;
    sc.async = false; // executa na ordem de insercao (trio antes do finder)
    var p = new Promise(function (ok, erro) { sc.onload = ok; sc.onerror = erro; });
    scriptsCarregando.set(src, p);
    document.body.appendChild(sc);
    return p;
  }

  function marcarFaixa() {
    if (document.querySelector('[data-colecao-sem-faixa-topo]')) return;
    Array.prototype.forEach.call(document.querySelectorAll('.biobio-copa-bar-section'), function (sec) {
      if (sec.querySelector('#copa-bar')) sec.classList.add('colecao-copa-viva');
    });
  }

  // biobio-trio.css/js (e o finder, quando a fonte e a do destaque). Uma carga por vez; falha zera para a proxima
  // intencao tentar de novo.
  function carregarTrio() {
    if (pronto()) return Promise.resolve();
    if (cargaTrio) return cargaTrio;
    var f = fonteAssets();
    if (!f) return Promise.reject(new Error('sem assets da gaveta'));
    var comFinder = f.hasAttribute('data-finder');
    marcarFaixa();
    var css = injetarCss(f.getAttribute('data-css'));
    if (comFinder) injetarCss(f.getAttribute('data-finder-css'), 'data-trio-finder-css').catch(noop);
    var esta = cargaTrio = css.then(function () {
      var js = [injetarJs(f.getAttribute('data-js'))];
      if (comFinder) js.push(injetarJs(f.getAttribute('data-finder-js')));
      return Promise.all(js);
    }).then(function () {
      if (!pronto()) throw new Error('biobio-trio.js nao iniciou');
    });
    esta.catch(function () { if (cargaTrio === esta) cargaTrio = null; });
    return esta;
  }

  function buscarSeletor(handle) {
    if (seletores.has(handle)) return seletores.get(handle);
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=biobio-kit-gaveta';
    var p = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sel = doc.querySelector('[data-kit-gaveta-fragmento] bundle-selector');
      if (!sel) throw new Error('fragmento sem seletor');
      if (sel.hasAttribute('data-kit-avulso')) throw new Error('kit em modo avulso');
      var tarefas = [];
      Array.prototype.forEach.call(doc.querySelectorAll('link[rel="stylesheet"][href]'), function (l) {
        tarefas.push(injetarCss(l.getAttribute('href')).catch(noop));
      });
      Array.prototype.forEach.call(doc.querySelectorAll('script[src]'), function (s) {
        tarefas.push(injetarJs(s.getAttribute('src')));
      });
      var no = document.importNode(sel, true);
      no.setAttribute('data-kit-gaveta-handle', handle);
      return Promise.all(tarefas).then(function () { return no; });
    });
    seletores.set(handle, p);
    p.catch(function () { seletores.delete(handle); });
    return p;
  }

  // O seletor do destaque e o dono do host: guardado na primeira troca e devolvido antes de o destaque agir.
  function guardarOriginal(h) {
    if (original) return;
    var atual = h.querySelector('bundle-selector');
    if (atual && !atual.hasAttribute('data-kit-gaveta-handle')) original = { no: atual };
  }

  function colocarNoHost(no) {
    var h = host();
    if (!h) return false;
    guardarOriginal(h);
    var atual = h.querySelector('bundle-selector');
    if (atual === no) return true;
    if (atual) atual.remove();
    h.appendChild(no);
    return true;
  }

  function restaurarOriginal() {
    if (!original) return;
    var h = host();
    if (!h) return;
    var atual = h.querySelector('bundle-selector');
    if (atual === original.no) return;
    if (atual) atual.remove();
    h.appendChild(original.no);
  }

  function ocupado(btn, sim) {
    if (sim) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  }

  // Cabecalho do kit: o biobio-trio.js poe o do destaque (lido uma vez da casca); aqui, logo depois do open
  // sincrono, troca pela sobrancelha com o nome do kit e o titulo de compra que o card traz.
  function cabecalho(btn) {
    var d = document.querySelector('[data-trio-drawer]');
    if (!d) return;
    var ey = d.querySelector('[data-trio-drawer-eyebrow]');
    var ti = d.querySelector('[data-trio-drawer-title]');
    var panel = d.querySelector('[data-trio-drawer-panel]');
    if (ey) {
      ey.textContent = btn.getAttribute('data-kit-gaveta-titulo') || '';
      ey.hidden = !ey.textContent;
    }
    if (ti) ti.textContent = btn.getAttribute('data-kit-gaveta-compra') || 'Comprar o kit';
    if (panel && ey && ti && ey.id && ti.id) panel.setAttribute('aria-labelledby', (ey.hidden ? '' : ey.id + ' ') + ti.id);
  }

  function irParaPdp(btn) {
    var url = btn.getAttribute('data-kit-gaveta-url');
    if (url) window.location.assign(url);
  }

  function abrir(btn) {
    var handle = btn.getAttribute('data-kit-gaveta');
    ocupado(btn, true);
    comTeto(Promise.all([carregarTrio(), buscarSeletor(handle)])).then(function (r) {
      ocupado(btn, false);
      var d = document.querySelector('[data-trio-drawer]');
      if (d && !d.hidden) return;
      if (!colocarNoHost(r[1])) throw new Error('sem host da gaveta');
      btn.dispatchEvent(new CustomEvent('trio:drawer-open', { bubbles: true, detail: { mode: 'bundle', trigger: btn } }));
      cabecalho(btn);
    }).catch(function (err) {
      ocupado(btn, false);
      if (window.console && console.warn) console.warn('[kit-gaveta]', handle, err && err.message);
      irParaPdp(btn);
    });
  }

  function intencao(ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest(SEL_BOTAO) : null;
    if (!b) return;
    carregarTrio().catch(noop);
    buscarSeletor(b.getAttribute('data-kit-gaveta')).catch(noop);
  }
  document.addEventListener('pointerdown', intencao, { passive: true });
  document.addEventListener('touchstart', intencao, { passive: true });

  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest(SEL_BOTAO) : null;
    if (!b) return;
    ev.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    abrir(b);
  });

  // Botao do destaque e gatilho do finder: o seletor do Trio volta para o host ANTES do biobio-trio.js (que escuta
  // em bolha) adotar o no.
  document.addEventListener('click', function (ev) {
    var g = ev.target && ev.target.closest ? ev.target.closest(SEL_DESTAQUE) : null;
    if (g) restaurarOriginal();
  }, true);

  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll(SEL_BOTAO + '[aria-busy]'), function (b) { ocupado(b, false); });
  });
})();
